export default class EditCompanies {
  initializeListeners() {
    $(".company-locations").bind("cocoon:after-remove", (event) => {
        $(".company-locations input:hidden").not("[name*=_destroy]").not("[name*=id]").attr('disabled', 'disabled');
    });
  }
}
